import pkg from '../package.json';

export const SDK_VERSION = pkg.version;
